{
  "version": 1,
  "asset_id": "7bd778cd-dfa3-426c-92ee-791bd2cb4cd7",
  "project_id": "5d92abc2-3725-40e6-9101-11b832091b05",
  "url": "/__l5e/assets-v1/7bd778cd-dfa3-426c-92ee-791bd2cb4cd7/cableplm-logo-on-dark.svg",
  "r2_key": "a/v1/5d92abc2-3725-40e6-9101-11b832091b05/7bd778cd-dfa3-426c-92ee-791bd2cb4cd7/cableplm-logo-on-dark.svg",
  "original_filename": "cableplm-logo-on-dark.svg",
  "size": 4621,
  "content_type": "image/svg+xml",
  "created_at": "2026-10-29T06:52:43Z"
}
